import { render, staticRenderFns } from "./LessonAssignmentDesktop.vue?vue&type=template&id=a4a430c2&scoped=true"
import script from "./LessonAssignmentDesktop.vue?vue&type=script&lang=js"
export * from "./LessonAssignmentDesktop.vue?vue&type=script&lang=js"
import style0 from "./LessonAssignmentDesktop.vue?vue&type=style&index=0&id=a4a430c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a430c2",
  null
  
)

export default component.exports